export default __webpack_public_path__ + "static/0056-a48dc331fa74d229d0e85609a25fb455.png";